import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { loadProvider } from '../../../../modules/Api';
import { useOnce, useJanitor } from '../../../../hooks';
import store from '../../../../store';
import AdminMenu from './AdminMenu';

const AdminMenuContainer = ({ providerId }) => {
  const janitor = useJanitor();
  const isSuperUser = useSelector(store.select.user.isSuperUser);
  const [profile, setProfile] = useState();

  useOnce(async () => {
    const pro = await janitor.addPromise(loadProvider(providerId));
    setProfile(pro);
  }, isSuperUser || null);

  if (!isSuperUser || !profile) {
    return null;
  }

  return <AdminMenu profile={profile} />;
};

export default AdminMenuContainer;
